import { render, staticRenderFns } from "./HeadImage.vue?vue&type=template&id=bdb9dcbe&"
import script from "./HeadImage.vue?vue&type=script&lang=js&"
export * from "./HeadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdb9dcbe')) {
      api.createRecord('bdb9dcbe', component.options)
    } else {
      api.reload('bdb9dcbe', component.options)
    }
    module.hot.accept("./HeadImage.vue?vue&type=template&id=bdb9dcbe&", function () {
      api.rerender('bdb9dcbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/HeadImage.vue"
export default component.exports